/** @module ChangeTracking/UpdateChangeLogConfigurationController */
define([
	"dojo/_base/declare",
	"csi/action/Controller",
	"csi/configuration",
    "csi/configurationUtil",
	"csi/locale",
	"csi/types",
	"csi/widget/MessageDialog"
], function(declare,Controller,configuration,configurationUtil,locale,types,MessageDialog) {

	return declare(Controller, {
		/**
		 * Prompt confirmation with buttons “Push” and “Cancel”.
		 * @param {Object} params
		 */
		confirmAction: function(params) {
			params = params || {};
			params.title = this.m_action.m_name;
			params.buttons = [MessageDialog.BUTTON_UPDATE + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL];
			this.inherited(arguments);
		},

		/**
		 * Override parent confirm behavior to use BUTTON_UPDATE instead of BUTTON_CONFIRM
		 * @param {String} confirm key
		 */
		onConfirm: function(/*String*/key) {
			// summary: if confirmed then begin processing the action
			if (key == MessageDialog.BUTTON_UPDATE) {
				this.preProcess();
			} else {
				this.postProcess();
			}
		},

		_preAction: function() {
		    return configurationUtil.preActionUpdateConfiguration(this);
		},

		postProcessSuccess: function() {
		    this.setProgress();
		    return configuration.refreshStatus();
		}
	});
});